import {ButtonBase} from '@material-ui/core';
import styled from 'styled-components';

const maxWidthLarge = '56rem';
const maxWidthMedium = '46rem';
const maxWidthSmall = '100%';

const sectionPaddingLarge = '4rem';
const sectionPaddingSmall = '2rem';
const sectionBackgroundColor = '#272727';
const sectionDividerColor = 'rgba(255, 255, 255, 0.24)';

const primaryButtonColor = '#0074E4';
const primaryButtonColorHover = 'rgb(40, 138, 232)';
const textButtonColorHover = 'rgb(0, 157, 223)';

const LicensingPage = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 3rem;

    ${p => p.theme.breakpoints.down('sm')} {
        padding-top: 2rem;
    }

    .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl {
        border: 1px solid #fff;
    }
    .engagement-section {
        margin: 0 auto;
        max-width: 800px;
    }
    .row.email {
        margin-bottom: 15px;
        input {
            height: 40px;
        }
    }
    .card.overlay {
        background-color: rgba(0, 0, 0, 0.35);
        .card-content {
            border-radius: 12px;
        }
    }

    .desc {
        font-size: 16px;
        line-height: 22px;
        color: rgba(255, 255, 255, 0.72);
    }
`;

const TitleContainer = styled.div`
    width: ${maxWidthLarge};
    display: flex;
    align-items: center;
    margin-bottom: 3rem;
    flex-direction: column;
    align-items: flex-start;

    .desc {
        margin-top: 16px;
        font-weight: 400;
        font-size: 20px;
        line-height: 25px;
        max-width: 75%;
    }

    ${p => p.theme.breakpoints.down('md')} {
        width: ${maxWidthMedium};
        margin-bottom: 2rem;
        .desc {
            max-width: 90%;
        }
    }
    ${p => p.theme.breakpoints.down('sm')} {
        width: calc(${maxWidthSmall} - 2rem);
        justify-content: center;
        margin-bottom: 1rem;
    }
`;

const Title = styled.span`
    font-size: 30px;
    line-height: 35px;
    letter-spacing: -0.3px;
    font-weight: 400;
    color: ${p => p.theme.colors.white};

    ${p => p.theme.breakpoints.down('sm')} {
        font-size: 24px;
        line-height: 30px;
        text-align: center;
    }
`;

const SectionContainer = styled.div`
    width: ${maxWidthLarge};
    background: ${sectionBackgroundColor};
    display: grid;
    grid-template-columns: 1fr 1px 1fr;
    gap: 0;
    margin-bottom: 2rem;

    ${p => p.theme.breakpoints.down('md')} {
        width: ${maxWidthMedium};
    }
    ${p => p.theme.breakpoints.down('sm')} {
        width: calc(${maxWidthSmall} - 2rem);
        grid-template-columns: none;
        grid-template-rows: auto 1px auto;
        margin-bottom: 1rem;
    }
`;

const HalfSectionContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    padding: ${sectionPaddingLarge};

    ${p => p.theme.breakpoints.down('md')} {
        padding: ${sectionPaddingSmall};
    }
`;

const Section1 = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1.5rem;
`;

const Section2 = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2rem;
`;

const InfoBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    align-items: flex-start;
`;

const IncludedOption = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
    margin: 1rem 0;
`;

const BottomLinksBlock = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    gap: 2rem;

    & > div {
        display: flex;
        align-items: center;
        gap: 1rem;
    }

    ${p => p.theme.breakpoints.down('sm')} {
        flex-wrap: wrap;
    }
`;

const Divider = styled.span`
    width: 1px;
    align-self: center;
    justify-self: center;
    background: ${sectionDividerColor};
    height: calc(100% - ${sectionPaddingLarge} - ${sectionPaddingLarge});

    ${p => p.theme.breakpoints.down('lg')} {
        height: calc(100% - ${sectionPaddingSmall} - ${sectionPaddingSmall});
    }
    ${p => p.theme.breakpoints.down('sm')} {
        height: 1px;
        width: calc(100% - ${sectionPaddingSmall} - ${sectionPaddingSmall});
    }
`;

const Text = styled.span<{fontSize?: string | number; lineHeight?: string | number; letterSpacing?: string; uppercase?: boolean; bold?: boolean}>`
    font-size: ${p => p.fontSize ?? '14px'};
    font-weight: ${p => (p.bold ? '700' : '400')};
    line-height: ${p => p.lineHeight ?? '20px'};
    letter-spacing: ${p => p.letterSpacing ?? '0'};
    color: ${p => p.theme.colors.white};
    text-transform: ${p => (p.uppercase ? 'uppercase' : 'none')};
`;

const UnderlinedText = styled(Text)`
    border-bottom: 1px solid ${p => p.theme.colors.white};
`;

const PrimaryButton = styled(ButtonBase)`
    background-color: ${primaryButtonColor};
    padding: 1.4rem 1.875rem;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    text-align: center;

    &:hover {
        text-decoration: none;
        background-color: ${primaryButtonColorHover};
    }
`;
const TextButton = styled(ButtonBase)`
    &:hover > ${UnderlinedText} {
        text-decoration: none;
        color: ${textButtonColorHover};
        border-bottom-color: ${textButtonColorHover};
    }
`;

export {
    LicensingPage,
    TitleContainer,
    Title,
    SectionContainer,
    HalfSectionContainer,
    Section1,
    Section2,
    InfoBlock,
    IncludedOption,
    BottomLinksBlock,
    Divider,
    Text,
    UnderlinedText,
    PrimaryButton,
    TextButton
};
